// extracted by mini-css-extract-plugin
module.exports = {"disabled":"ToggleSwitch_disabled__2HVxd","switch":"ToggleSwitch_switch__3GUlz"};